
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformHorizontal as ObiTransformHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transform-horizontal.js';
 
 
 

 
 export const ObiTransformHorizontal = createComponent({
   react: React,
   tagName: 'obi-transform-horizontal',
   elementClass: ObiTransformHorizontalElement,
   events: {
     
   }
  });
 
 